import { defineMessages, useIntl } from "react-intl";

import {
  MutationActions,
  QueryKeys,
  queryClient,
  useEntityMutation,
} from "@/api/core";
import { CarouselGroupKeys } from "@/api/hooks/carousels/useCarouselGroups";
import { useApi } from "@/hooks";
import { groupRelationshipSchema } from "@/schemas";
import toast from "@/toast";

import { useUnsubscribeToGroup } from "./useUnsubscribeToGroup";

const messages = defineMessages({
  muteSuccess: { id: "group.mute.success", defaultMessage: "Muted the group" },
  muteAndUnsubscribeSuccess: {
    id: "group.mute_and_unsubscribe.success",
    defaultMessage: "Muted and unsubscribed from the group",
  },
});

interface Variables {
  id: string;
  isSubscribed?: boolean;
}

function useMuteGroup() {
  const api = useApi();
  const intl = useIntl();
  const unsubscribeToGroup = useUnsubscribeToGroup();

  return useEntityMutation({
    globalQueryKey: QueryKeys.groupRelationships.global,
    action: MutationActions.UPDATE,
    schema: groupRelationshipSchema,
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/groups/${variables.id}/mute`),
    onSuccess(_response, variables) {
      queryClient.invalidateQueries({ queryKey: CarouselGroupKeys.groups });

      if (variables.isSubscribed) {
        unsubscribeToGroup.mutate(
          { id: variables.id },
          {
            onSuccess() {
              toast.success(
                intl.formatMessage(messages.muteAndUnsubscribeSuccess),
              );
            },
          },
        );
      } else {
        toast.success(intl.formatMessage(messages.muteSuccess));
      }
    },
  });
}

export { useMuteGroup };
